import React from "react";

const Statistics = () => {
  return <></>;
};

export default Statistics;
